import React from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { Button, Space, Typography, message } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { ingestionStore } from './store/IngestionStore';
import { Step1Variations } from './steps/Step1Variations';

const { Title } = Typography;

export const IngestionCreate = observer(() => {
    const history = useHistory();

    const handleSubmit = async (payload) => {
        try {
            const created = await ingestionStore.createItem(payload);
            message.success('Pipeline item created');
            history.push(`/ingestion/${created.id}`);
        } catch (e) {
            message.error(e.message || 'Failed to create item');
        }
    };

    return (
        <div style={{ padding: 24 }}>
            <Space style={{ marginBottom: 16 }}>
                <Button icon={<ArrowLeftOutlined />} onClick={() => history.push('/ingestion')}>
                    Back
                </Button>
                <Title level={3} style={{ margin: 0 }}>
                    New pipeline item
                </Title>
            </Space>
            <Step1Variations saving={ingestionStore.saving} onSubmit={handleSubmit} />
        </div>
    );
});
